import { useMemo } from 'react';

import { Passport } from '@dreryk/personal-external-identifier-common-api';

import { FieldControllerProps, ValidateResult, ValidationRules } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

import { identityDocumentTranslationKeys } from '../../../../../../../translations';

import { IdentityDocumentTypeVisitor } from './IdentityDocumentTypeField';

type IdentityDocumentValueFieldProps = FieldControllerProps<'identityDocumentValue', string | null> & {
   readonly identityDocumentTypeVisitor: IdentityDocumentTypeVisitor;
};

export const IdentityDocumentValueField = (props: IdentityDocumentValueFieldProps): JSX.Element => {
   const { identityDocumentTypeVisitor, required } = props;

   const validationRules = useMemo<ValidationRules<{ identityDocumentValue: string | null }>>(() => {
      return {
         required: required,
         maxLength: identityDocumentTypeVisitor<number | undefined>({
            visitPassport: () => Passport.MAX_LENGTH,
         }),
         validate: (value) =>
            identityDocumentTypeVisitor<ValidateResult>({
               visitPassport: () => {
                  return Passport.isValueValid(value as string)
                     ? undefined
                     : identityDocumentTranslationKeys.value.validate.invalidPassport;
               },
            }),
      };
   }, [identityDocumentTypeVisitor, required]);

   return (
      <TextInput
         testId={props.name}
         label={identityDocumentTranslationKeys.value.label}
         controller={props.register(props.name, validationRules)}
         defaultValue={props.defaultValue}
      />
   );
};
